export default "__VITE_ASSET__2c80250d__"